import { pipe } from 'ramda';
import { createSelector } from 'reselect';
import { deepEquals } from '@nike/ciclp-utils';
import { ownPropsSelector } from '../../utils/ownPropsSelector';
import { dataSelector } from './dataSelector';
import { extractUrlIngredients } from '../../services/transforms/utils';

export const urlsSelector = createSelector(
  dataSelector,
  data => data?.urls ?? [],
);

export const urlSelector = createSelector(
  urlsSelector,
  ownPropsSelector,
  (urls, destination = {}) => {
    const pickedDestination =
      extractUrlIngredients(destination)?.urlIngredients ?? {};
    const urlEntry = urls?.find(
      pipe(
        arr => arr?.[0],
        x => deepEquals(x, pickedDestination),
      ),
    );
    return urlEntry ? urlEntry.at(-1) : null;
  },
);
